import React from "react";
import { useTranslation } from "../../i18n";

const EmptyStateMenu = () => {
  const { t } = useTranslation();
  return (
    <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
      <img
        src={require("../../assets/images/empty-state.png")}
        alt=""
        width={"30%"}
        loading="lazy"
        className="img-fluid images-gray"
      />
      <p className="font-vietnam-300 text-center">
        {t.empty.message[0]} <br />
        {t.empty.message[1]}
      </p>
    </div>
  );
};

export default EmptyStateMenu;
